import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { CompanyService } from '../company.service';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddGroupReportingComponent } from '../add-group-reporting/add-group-reporting.component'
import { ToastService } from '../../shared/toast.service';
import { UnsavedmsgModalComponent } from '../../unsavedmsg-modal/unsavedmsg-modal.component';
import { ConfirmDialogService } from '../../confirm-dialog/confirm-dialog.service';
import { AppService } from '../../app.service'
import { Router } from '@angular/router';
import { AdobelaunchService } from '../../_services/adobelaunch.service';
import { selectGroupCode, selectGroupReportEnabled, selectPrfName, selectPrfNumber, selectPrfYear } from 'src/app/store/selectors/app.selector';
import { Store } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
@Component({
    selector: 'app-groupreporting',
    templateUrl: './groupreporting.component.html',
    styleUrls: ['./groupreporting.component.scss'],
    standalone: false
})
export class GroupreportingComponent implements OnInit, AfterViewInit {

  @Input() title;
  compno: any;
  currentYear: number;
  prfNumber: string;
  prfName: string;
  groupreporting: { [key: string]: any } = {};
  isgroupreporting: boolean;
  groupreportingform: UntypedFormGroup;
  passed: boolean;
  showPageError: boolean;
  unsavedData: boolean = false;
  aval: string;
  nval: string;
  show: boolean = true;
  spinnersave: boolean;
  spinnergroupcopy: boolean = false;
  isComplete: boolean = false;
  isLocked: boolean;
  isReadOnly: boolean;
  isReadOnlyAdmin: boolean;
  groupcode: any;
  invalidgroupcompany: any
  groupreportloaded: Promise<boolean>;
  isDelete: boolean;
  nvalError: boolean;
  avalError: boolean;
  isPrioryearCopyEnabled: boolean = false;
  hasGroupDetails: boolean = false;
  hasAutoAddedCompany: boolean = false;
  constructor(private router: Router, private appService: AppService, private confirmDialogService: ConfirmDialogService, private companyService: CompanyService, public builder: UntypedFormBuilder, private modalService: NgbModal, public toastService: ToastService,
    private readonly AdobelaunchService:AdobelaunchService, private readonly store: Store,) {
    this.groupreportingform = this.builder.group({});
  }

  ngAfterViewInit() {
    this.AdobelaunchService.EventEndDispatch();
    }
  ngOnInit(): void {
    this.removePrevAlerts();
    this.companyService.groupreportingCompleted.subscribe(result => {
      this.isComplete = result;
    });
    this.store.select(selectPrfName).subscribe(prfName => {
          this.prfName = prfName;
        });
     
        this.store.select(selectPrfNumber).subscribe(prfNumber => {
          this.prfNumber = prfNumber || '';
          this.compno = prfNumber || '';
        });
    
         this.store.select(selectPrfYear).subscribe(year => {
          this.currentYear = year;
        });
    this.store.select(selectGroupCode).subscribe(groupCode => {
          this.groupcode = groupCode;
          if (!this.groupcode) {
            this.companyService.getgroup().subscribe((value) => {
              this.groupcode = value;
            });
          }
        });

    this.isLocked = this.companyService.isEditLocked;
    this.isReadOnlyAdmin = this.appService.isReadonlyAdmin;

    this.store.select(selectGroupReportEnabled).subscribe(enabled => {
      const groupreportenabled = enabled == 'on';
      this.isReadOnly = this.isLocked || this.isReadOnlyAdmin;
    });
    this.getPrgress();
    this.loadGroupReporting();
  }

  getPrgress() {
    this.companyService.getCustomerPrfProgress(this.currentYear, this.compno, this.groupcode).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          if (!this.isComplete)
            this.companyService.groupreportingInProgress.next(true)
        }
      },
      error: (error) => {
        this.router.navigate(['/apifailure']);
      }
    });


  }

  loadGroupReporting() {
    this.show = true;
    this.companyService.loadGroupReport(this.currentYear, this.compno, this.groupcode).subscribe({
      next: (resp) => {
        if (resp["message"] == "Success") {
          this.groupreporting = resp["groupcompanydetails"]
          // group reporting enabled is set to true when group reporting data is loaded successfully.
          this.isgroupreporting = true;
          this.show = false;

          // Track whether the API returned any group company details from PDB.
          this.hasGroupDetails = Array.isArray(this.groupreporting) && this.groupreporting.length > 0;

          // Ensure the current company is present in the list so the user can
          // select it and enter NAIC/AMBest, even when the API returns an empty list.
          if (!Array.isArray(this.groupreporting)) {
            this.groupreporting = [];
          }
          const alreadyInList = this.groupreporting.some(
            (item: any) => item.No && item.No.toUpperCase() === this.compno.toUpperCase()
          );
          if (!alreadyInList) {
            const currentCompany: { [key: string]: any } = {
              No: this.compno,
              Name: this.prfName || '',
              chkvalue: false,
              NAIC: '',
              AMBest: '',
              VisibleTo: '',
              chktext: 'Include',
              TakenBy: this.compno,
              // Marks a PRF that doesn't exist in PDB group companies but was added
              // automatically because the API returned other group companies.
              isAutoAdded: this.hasGroupDetails
            };
            this.hasAutoAddedCompany = this.hasGroupDetails;
            this.groupreporting.unshift(currentCompany);
            // prfName may still be loading asynchronously — update name when it arrives.
            if (!this.prfName) {
              this.store.select(selectPrfName).pipe(
                filter(name => !!name),
                take(1)
              ).subscribe(name => {
                currentCompany.Name = name || '';
              });
            }
            // The current company's own saved NAIC/AMBest are stored in company info,
            // not in getgroupcompanydetails — fetch and populate them so they persist.
            this.companyService.loadCompanyInformation(this.currentYear, this.compno, this.groupcode).subscribe({
              next: (compResp) => {
                if (compResp["message"] == "Success" && compResp["companydata"]) {
                  const companyData = compResp["companydata"];
                  if (!currentCompany.Name && companyData.compname) {
                    currentCompany.Name = companyData.compname;
                  }
                  currentCompany.NAIC = companyData.naic || '';
                  currentCompany.AMBest = companyData.ambest || '';
                  if (currentCompany.NAIC || currentCompany.AMBest) {
                    currentCompany.chkvalue = true;
                  }
                }
              }
            });
          }

          for (let i = 0; i < this.groupreporting.length; i++) {
            if (this.groupreporting[i].chkvalue == 'true')
              this.groupreporting[i].chkvalue = true;
            if (this.groupreporting[i].chkvalue == 'false')
              this.groupreporting[i].chkvalue = false;
            this.tableRow(i);
          }
          this.groupreportloaded = Promise.resolve(true)
        }
      },
      error: (error) => {
        this.router.navigate(['/apifailure']);
      }
    });
  }
  onFormValueChanges(data) {
    for (const key in this.groupreportingform.controls) {
      const control = this.groupreportingform.get(key);
      this.groupreporting[key] = control.value;
    }
  }
  tableRow(i: number, scenario?: string) {

    this.groupreportingform.addControl('No_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('Name_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('chkvalue_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('NAIC_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('AMBest_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('VisibleTo_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('chktext_' + i, new UntypedFormControl(''));
    this.groupreportingform.addControl('TakenBy_' + i, new UntypedFormControl(''));
  }

  add() {
    const modalRef = this.modalService.open(AddGroupReportingComponent);

    modalRef.componentInstance.title = "Add Group Reporting";
    modalRef.componentInstance.prfYear = this.currentYear;
    modalRef.componentInstance.companyno = this.compno;

    modalRef.result.then((result) => {
      if (result) {

        result.chkvalue = true;

        result.TakenBy = this.compno;

        result.VisibleTo = '';
        result.chktext = 'Include';
        let newRows = this.groupreporting.filter(function (x) { return x.No.toUpperCase().includes('NEW') })
          .map(function (item) {
            return parseInt(item.No.replace('NEW', ''));
          });
        newRows.sort(function (a, b) { return a - b });
        if (newRows.length > 0) {
          result.No = 'NEW' + (newRows[newRows.length - 1] + 1)
        } else {
          result.No = 'NEW1'
        }
        this.tableRow(this.groupreporting.length)
        this.groupreporting.push(result)
        this.unsavedData = true;
      }
    });

  }

  deletegroupreport(gr) {
    this.confirmDialogService.confirmThis('Delete', 'Do you want to delete the company : ' + gr.No.toUpperCase() + '?', () => {
      if (gr == this.invalidgroupcompany) {
        this.groupreportingform.setErrors(null);
        this.showPageError = false;
      }
      this.groupreporting = this.groupreporting.filter(item => item !== gr);
      this.isDelete = true;
    }, () => {

    });
    this.unsavedData = true;

  }

  onsubmit() {
    this.toastService.remove(this.toastService.toasts[0]);
    this.spinnersave = true;
    for (const group of Object.values(this.groupreporting)) {
      let valid = true;
      if (group.chkvalue) {
        valid = this.confirmval(group);
      }
      if (!valid) {
        this.invalidgroupcompany = group;
        break;
      }
    }

    if (this.groupreportingform.valid) {
      this.companyService.disableCompanyList.next(true)
      this.companyService.clearStatus();
      this.unsavedData = false;
      this.showPageError = false;
      let mode = '';
      if (this.isDelete)
        mode = "delete"
      this.companyService.SaveGroupReport(this.currentYear, this.compno, this.groupreporting, this.groupcode, mode).subscribe({
        next: (resp) => {
          if (resp["message"] == "Success") {
            this.getPrgress();
            this.toastService.show(resp["status_msg"], { classname: 'bg-success text-light', delay: 3000 });
            this.spinnersave = false;
            this.isDelete = false;
            this.companyService.disableCompanyList.next(false);
          }
        },
        error: (error) => {
          this.router.navigate(['/apifailure']);
        }
      });
    }
  }

  onprioryeargroupcopy() {
    this.toastService.remove(this.toastService.toasts[0]);
    this.spinnergroupcopy = true;
    this.confirmDialogService.confirmThis('Prior Year Group Copy', 'Existing NAIC Mapping and Group Company Informations for the PRF will be updated. Click \'Yes\' to Confirm.', () => {
      this.companyService.onPriorYearGroupCopy(this.currentYear, this.compno).subscribe({
        next: (resp) => {
          if (resp["message"] == "Success") {
            this.getPrgress();
            this.toastService.show(resp["data"], { classname: 'bg-success text-light', delay: 3000 });
            this.spinnergroupcopy = false;
            this.isDelete = false;
            this.companyService.disableCompanyList.next(false);
            this.loadGroupReporting();
          }
        },
        error: (error) => {
          this.router.navigate(['/apifailure']);
        }
      });
    }, () => {
      this.spinnergroupcopy = false;
    });
  }

  hasUnsavedData() {
    return this.unsavedData;
  }
  onchange() {
    if (!this.isReadOnly) {
      this.unsavedData = true;
    }

  }
  validateInput(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    return false;
  }
  onNativeChange(e, row) {


    const isChecked = e.target.checked;
    if (this.groupreporting[row].chktext == "Include" && isChecked) {
      this.groupreporting[row].TakenBy = this.compno;

    } else if (this.groupreporting[row].chktext == "Include" && !isChecked) {
      this.groupreporting[row].NAIC = '';
      this.groupreporting[row].AMBest = '';
      this.groupreporting[row].TakenBy = ''

    }

    this.unsavedData = true;
  }

  confirmval(truegroup): boolean {

    this.nval = truegroup['NAIC'];
    this.aval = truegroup['AMBest'];

    if (this.nval != '' || this.aval != '') {
      this.groupreportingform.setErrors(null);
      this.showPageError = false;

      if (!this.validateField(this.nval, 'nvalError')) {
        return false;
      }

      if (!this.validateField(this.aval, 'avalError')) {
        return false;
      }

      return true;
    } else {
      this.groupreportingform.setErrors({ 'invalid': true });
      this.showPageError = true;
      this.nvalError = false;
      this.avalError = false;
      this.spinnersave = false;
      return false;
    }
  }

  private validateField(value: string, errorField: string): boolean {
    if (value != '') {
      if (/^\d+$/.test(value)) {
        this[errorField] = false;
        this.groupreportingform.setErrors(null);
      } else {
        this.groupreportingform.setErrors({ 'invalid': true });
        this[errorField] = true;
        this.spinnersave = false;
        return false;
      }
    } else {
      this[errorField] = false;
      this.groupreportingform.setErrors(null);
    }
    return true;
  }


  openPageChangeModal() {
    const modalRef = this.modalService.open(UnsavedmsgModalComponent);
    modalRef.componentInstance.name = 'New';

    modalRef.result.then((result) => {
      if (result) {
        this.onsubmit();
      }
    });
  }

  removePrevAlerts(){
    for (let i = this.toastService.toasts.length-1; i >= 0; i--) {
      this.toastService.remove(this.toastService.toasts[i]);
    }
  }
}
